























import Vue from "vue";

import GuestModel from "@/models/GuestModel";
import OptionModel from "@/models/OptionModel";
import session from "@/global/session";

import { version } from "../package.json";

import "../node_modules/font-awesome/scss/font-awesome.scss";
import "./assets/scss/style.scss";

export default Vue.extend({
	data() {
		return {
			pageName: this.$route.name as string,
			appDetails: {
				version: version,
				mode: process.env.NODE_ENV === "development" ? "DEV" : "PROD",
			},
			isLoaded: false as boolean,
			isAdminPage: false as boolean,
		};
	},

	async mounted() {
		this.isAdminPage = this.$route.meta.isAdminPage || false;

		try {
			// Load the whole Options tab into the store before the first view
			// renders, so option-driven UI never flashes a wrong default.
			await this.loadOptions();
		} catch (e) {
			// Non-fatal — views fall back to their defaults.
		}

		this.setDocumentTitle();
		this.setFavicon();
		this.isLoaded = true;
	},

	computed: {
		isAdminArea(): boolean {
			return (this.$route.path || "").indexOf("/admin") === 0;
		},
	},

	methods: {
		logout() {
			session.clear();
			this.$router.push({ name: "BidderLogin" });
		},

		setDocumentTitle() {
			const eventName = this.$store.getters.getOptionValue("event_name");
			if (eventName) document.title = eventName;
		},

		setFavicon() {
			const faviconUrl = this.$store.getters.getOptionValue("event_favicon");
			if (!faviconUrl) return;

			// Point both the browser-tab favicon and the apple-touch icon at the
			// event's icon, creating the link elements if the page lacks them.
			["icon", "apple-touch-icon"].forEach((rel) => {
				let link = document.head.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
				if (!link) {
					link = document.createElement("link");
					link.setAttribute("rel", rel);
					document.head.appendChild(link);
				}
				link.setAttribute("href", faviconUrl);
			});
		},

		async loadGuestList() {
			this.$store.commit("resetGuestList");

			const endpoint = process.env.VUE_APP_SHEETY_ENDPOINT + "/attendees";

			const response = await fetch(endpoint, {
				method: "GET",
				cache: "no-store",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + process.env.VUE_APP_BEARER_TOKEN,
				},
			});
			const data = await response.json();

			const attendees = data.attendees;

			attendees.forEach((guest: any) => {
				const newGuest = new GuestModel(guest);
				this.$store.commit("addGuest", newGuest);
			});

			return attendees;
		},

		async loadOptions() {
			const endpoint = process.env.VUE_APP_SHEETY_ENDPOINT + "/options";

			const response = await fetch(endpoint, {
				method: "GET",
				cache: "no-store",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + process.env.VUE_APP_BEARER_TOKEN,
				},
			});
			const data = await response.json();

			const options = data.options;

			options.forEach((option: any) => {
				const newOption = new OptionModel({ id: option.id, key: option.key.replace(/\r?\n|\r/g, ""), value: option.value });
				this.$store.commit("addOption", newOption);
			});

			return options;
		},
	},

	watch: {
		$route(to, from) {
			this.pageName = to.name as string;
			this.isAdminPage = to.meta.isAdminPage || false;
		},
	},
});
